/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamUserRole,
    IamUserRoleFromJSON,
    IamUserRoleFromJSONTyped,
    IamUserRoleToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateIamUserRoleResponse
 */
export interface CreateIamUserRoleResponse {
    /**
     * 
     * @type {IamUserRole}
     * @memberof CreateIamUserRoleResponse
     */
    iamUserRole: IamUserRole;
}

export function CreateIamUserRoleResponseFromJSON(json: any): CreateIamUserRoleResponse {
    return CreateIamUserRoleResponseFromJSONTyped(json, false);
}

export function CreateIamUserRoleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIamUserRoleResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamUserRole': IamUserRoleFromJSON(json['iam_user_role']),
    };
}

export function CreateIamUserRoleResponseToJSON(value?: CreateIamUserRoleResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_user_role': IamUserRoleToJSON(value.iamUserRole),
    };
}


